import React, { useState, useEffect } from "react";
import { Icon } from "semantic-ui-react";
import "./ScrollToTop.scss";

const CONTAINER_CLASS = "admin-layout__right-content";

export function ScrollToTop({ threshold = 300 }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const container = document.querySelector(`.${CONTAINER_CLASS}`);
    if (!container) return;

    const onScroll = () => setVisible(container.scrollTop > threshold);
    container.addEventListener("scroll", onScroll, { passive: true });
    return () => container.removeEventListener("scroll", onScroll);
  }, [threshold]);

  const handleClick = () => {
    const container = document.querySelector(`.${CONTAINER_CLASS}`);
    if (container) {
      container.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  if (!visible) return null;

  return (
    <button
      className="scroll-to-top"
      onClick={handleClick}
      aria-label="Volver arriba"
    >
      <Icon name="chevron up" />
    </button>
  );
}
